"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.IconExpandLess = function (_a) {
    var color = _a.color, style = _a.style;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 155.948", style: style },
        React.createElement("path", { fill: color, d: "M127.99 0L0 127.99l27.96 27.96L127.99 55.92l100.05 100.03L256 127.99 127.99 0z" })));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/IconExpandLess.tsx
// module id = 307
// module chunks = 0